import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e9283df"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-group row ml-4" }
const _hoisted_2 = { class: "col-sm-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "subtitle" }, "Logo")
], -1))
const _hoisted_4 = { class: "table table-sm table-borderless" }
const _hoisted_5 = { class: "col-sm-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "subtitle" }, "Colours")
], -1))
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-8" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Primary colour")
  ])
], -1))
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-sm-6 d-flex align-items-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-8" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Secondary colour")
  ])
], -1))
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-sm-6 d-flex align-items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-8" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Background colour")
  ])
], -1))
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-sm-6 d-flex align-items-center" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-8" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Frontpage company address colour")
  ])
], -1))
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-sm-6 d-flex align-items-center" }
const _hoisted_20 = { class: "col-sm-3" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Switches", -1))
const _hoisted_22 = { class: "form-group row" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Show meters", -1))
const _hoisted_24 = { class: "col-sm-6" }
const _hoisted_25 = { class: "form-group row" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Show keys", -1))
const _hoisted_27 = { class: "col-sm-6" }
const _hoisted_28 = { class: "form-group row" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Show alarms", -1))
const _hoisted_30 = { class: "col-sm-6" }
const _hoisted_31 = { class: "form-group row" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Show appliances and manuals", -1))
const _hoisted_33 = { class: "col-sm-6" }
const _hoisted_34 = { class: "form-group row" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Show item lozenges", -1))
const _hoisted_36 = { class: "col-sm-6" }
const _hoisted_37 = { class: "form-group row" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Hide room list on alarms", -1))
const _hoisted_39 = { class: "col-sm-6" }
const _hoisted_40 = { class: "col-sm-3" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Show on main page", -1))
const _hoisted_42 = { class: "form-group row" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Show meters on main page", -1))
const _hoisted_44 = { class: "col-sm-6" }
const _hoisted_45 = { class: "form-group row" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Show keys on main page", -1))
const _hoisted_47 = { class: "col-sm-6" }
const _hoisted_48 = { class: "form-group row" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Show alarms on main page", -1))
const _hoisted_50 = { class: "col-sm-6" }
const _hoisted_51 = { class: "form-group row" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Show appliances and manuals on main page", -1))
const _hoisted_53 = { class: "col-sm-6" }
const _hoisted_54 = { class: "form-group row" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Show general notes on main page", -1))
const _hoisted_56 = { class: "col-sm-6" }
const _hoisted_57 = { class: "form-group row" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-6 col-form-label" }, "Show compliance sections on main page", -1))
const _hoisted_59 = { class: "col-sm-6" }

import _ from "lodash";

import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import Logos from '@/components/logo/Logos.vue';
import { DxSwitch } from 'devextreme-vue/switch';
import { CustomerDictionary, Photo } from "@/models";


export default /*#__PURE__*/_defineComponent({
  __name: 'Logo',
  setup(__props) {

const store = useStore();
const router = useRouter();
const validColorCode = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i;

const customerdictionary = computed((): CustomerDictionary => store.getters['customerdictionary/current']);

const setCustomerDictionaryDeep = async (payload: {
    path: string;
    data: any;
  }) => {
  await store.dispatch('customerdictionary/setCustomerDictionaryDeep', payload);
};

const primarycolour = computed({
  get: () => customerdictionary.value.report_configuration.primarycolour,
  set: value => {
    if(validColorCode.test(value)){
      setCustomerDictionaryDeep({
        path: "report_configuration.primarycolour",
        data: value,
      });
    } else {
      setCustomerDictionaryDeep({
        path: "report_configuration.primarycolour",
        data: customerdictionary.value.report_configuration.primarycolour,
      });
    }  
  }
});
const secondarycolour = computed({
  get: () => customerdictionary.value.report_configuration.secondarycolour,
  set: value => {
    if(validColorCode.test(value)){
      setCustomerDictionaryDeep({
        path: "report_configuration.secondarycolour",
        data: value,
      });
    } else {
      setCustomerDictionaryDeep({
        path: "report_configuration.secondarycolour",
        data: customerdictionary.value.report_configuration.secondarycolour,
      });
    }  
  }
});

const backgroundcolour = computed({
  get: () => customerdictionary.value.report_configuration.backgroundcolour,
  set: value => {
    if(validColorCode.test(value)){
      setCustomerDictionaryDeep({
        path: "report_configuration.backgroundcolour",
        data: value,
      });
    } else {
      setCustomerDictionaryDeep({
        path: "report_configuration.backgroundcolour",
        data: customerdictionary.value.report_configuration.backgroundcolour,
      });
    }  
  }
});

const frontpagetextcolour = computed({
  get: () => customerdictionary.value.report_configuration.frontpagetextcolour,
  set: value => {
    if(validColorCode.test(value)){
      setCustomerDictionaryDeep({
        path: "report_configuration.frontpagetextcolour",
        data: value,
      });
    } else {
      setCustomerDictionaryDeep({
        path: "report_configuration.frontpagetextcolour",
        data: customerdictionary.value.report_configuration.frontpagetextcolour,
      });
    }  
  }
});

const showtenants = computed({
  get: () => customerdictionary.value.report_configuration.showtenants,
  set: value => setCustomerDictionaryDeep({
      path: "report_configuration.showtenants",
      data: value,
    })
});

const showmeters = computed({
  get: () => customerdictionary.value.report_configuration.showmeters,
  set: value => setCustomerDictionaryDeep({
      path: "report_configuration.showmeters",
      data: value,
    })
});

const showkeys = computed({
  get: () => customerdictionary.value.report_configuration.showkeys,
  set: value => setCustomerDictionaryDeep({
      path: "report_configuration.showkeys",
      data: value,
    })
});

const showalarms = computed({
  get: () => customerdictionary.value.report_configuration.showalarms,
  set: value => setCustomerDictionaryDeep({
      path: "report_configuration.showalarms",
      data: value,
    })
});

const showappliancesandmanuals = computed({
  get: () => customerdictionary.value.report_configuration.showappliancesandmanuals,
  set: value => setCustomerDictionaryDeep({
      path: "report_configuration.showappliancesandmanuals",
      data: value,
    })
});

const showgeneralnotesonhomepage = computed({
  get: () => customerdictionary.value.report_configuration.showgeneralnotesonhomepage,
  set: value => setCustomerDictionaryDeep({
      path: "report_configuration.showgeneralnotesonhomepage",
      data: value,
    })
});

const showtenantsonhomepage = computed({
  get: () => customerdictionary.value.report_configuration.showtenantsonhomepage,
  set: value => setCustomerDictionaryDeep({
      path: "report_configuration.showtenantsonhomepage",
      data: value,
    })
});

const showmetersonhomepage = computed({
  get: () => customerdictionary.value.report_configuration.showmetersonhomepage,
  set: value => setCustomerDictionaryDeep({
      path: "report_configuration.showmetersonhomepage",
      data: value,
    })
});

const showkeysonhomepage = computed({
  get: () => customerdictionary.value.report_configuration.showkeysonhomepage,
  set: value => setCustomerDictionaryDeep({
      path: "report_configuration.showkeysonhomepage",
      data: value,
    })
});

const showalarmsonhomepage = computed({
  get: () => customerdictionary.value.report_configuration.showalarmsonhomepage,
  set: value => setCustomerDictionaryDeep({
      path: "report_configuration.showalarmsonhomepage",
      data: value,
    })
});

const showappliancesandmanualsonhomepage = computed({
  get: () => customerdictionary.value.report_configuration.showappliancesandmanualsonhomepage,
  set: value => setCustomerDictionaryDeep({
      path: "report_configuration.showappliancesandmanualsonhomepage",
      data: value,
    })
});

const showitemlozenges = computed({
  get: () => customerdictionary.value.report_configuration.showitemlozenges,
  set: value => setCustomerDictionaryDeep({
      path: "report_configuration.showitemlozenges",
      data: value,
    })
});

const showcompliancesectionsonhomepage = computed({
  get: () => customerdictionary.value.report_configuration.showcompliancesectionsonhomepage,
  set: value => setCustomerDictionaryDeep({
      path: "report_configuration.showcompliancesectionsonhomepage",
      data: value,
    })
});

const hideroomsonalarms = computed({
  get: () => customerdictionary.value.report_configuration.hideroomsonalarms,
  set: value => setCustomerDictionaryDeep({
      path: "report_configuration.hideroomsonalarms",
      data: value,
    })
});

const getLogos = () => {
  return _.get(customerdictionary.value, 'report_configuration.logo', []);
};
const getLogoKey = () => {
  const logos = getLogos();
  return logos.map((l: Photo) => l.src).concat('-');
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("table", _hoisted_4, [
        (_openBlock(), _createBlock(Logos, {
          photos: getLogos(),
          key: `logo${getLogoKey()}`,
          path: 'report_configuration.logo',
          target: 'customerdictionary'
        }, null, 8, ["photos", "path"]))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              type: "color",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((primarycolour).value = $event)),
              class: "form-control",
              style: {"width":"75px","margin-right":"2px"}
            }, null, 512), [
              [_vModelText, primarycolour.value]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((primarycolour).value = $event)),
              class: "form-control",
              style: {"width":"100px"}
            }, null, 512), [
              [
                _vModelText,
                primarycolour.value,
                void 0,
                { lazy: true }
              ]
            ])
          ])
        ]),
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _withDirectives(_createElementVNode("input", {
              type: "color",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((secondarycolour).value = $event)),
              class: "form-control",
              style: {"width":"75px","margin-right":"2px"}
            }, null, 512), [
              [_vModelText, secondarycolour.value]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((secondarycolour).value = $event)),
              class: "form-control",
              style: {"width":"100px"}
            }, null, 512), [
              [
                _vModelText,
                secondarycolour.value,
                void 0,
                { lazy: true }
              ]
            ])
          ])
        ]),
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _withDirectives(_createElementVNode("input", {
              type: "color",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((backgroundcolour).value = $event)),
              class: "form-control",
              style: {"width":"75px","margin-right":"2px"}
            }, null, 512), [
              [_vModelText, backgroundcolour.value]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((backgroundcolour).value = $event)),
              class: "form-control",
              style: {"width":"100px"}
            }, null, 512), [
              [
                _vModelText,
                backgroundcolour.value,
                void 0,
                { lazy: true }
              ]
            ])
          ])
        ]),
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _withDirectives(_createElementVNode("input", {
              type: "color",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((frontpagetextcolour).value = $event)),
              class: "form-control",
              style: {"width":"75px","margin-right":"2px"}
            }, null, 512), [
              [_vModelText, frontpagetextcolour.value]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((frontpagetextcolour).value = $event)),
              class: "form-control",
              style: {"width":"100px"}
            }, null, 512), [
              [
                _vModelText,
                frontpagetextcolour.value,
                void 0,
                { lazy: true }
              ]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("fieldset", null, [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_unref(DxSwitch), {
              value: showmeters.value,
              onValueChanged: _cache[8] || (_cache[8] = ($event: any) => (showmeters.value = $event.value))
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_unref(DxSwitch), {
              value: showkeys.value,
              onValueChanged: _cache[9] || (_cache[9] = ($event: any) => (showkeys.value = $event.value))
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_unref(DxSwitch), {
              value: showalarms.value,
              onValueChanged: _cache[10] || (_cache[10] = ($event: any) => (showalarms.value = $event.value))
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_unref(DxSwitch), {
              value: showappliancesandmanuals.value,
              onValueChanged: _cache[11] || (_cache[11] = ($event: any) => (showappliancesandmanuals.value = $event.value))
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, [
            _createVNode(_unref(DxSwitch), {
              value: showitemlozenges.value,
              onValueChanged: _cache[12] || (_cache[12] = ($event: any) => (showitemlozenges.value = $event.value))
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _hoisted_38,
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_unref(DxSwitch), {
              value: hideroomsonalarms.value,
              onValueChanged: _cache[13] || (_cache[13] = ($event: any) => (hideroomsonalarms.value = $event.value))
            }, null, 8, ["value"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_40, [
      _createElementVNode("fieldset", null, [
        _hoisted_41,
        _createElementVNode("div", _hoisted_42, [
          _hoisted_43,
          _createElementVNode("div", _hoisted_44, [
            _createVNode(_unref(DxSwitch), {
              value: showmetersonhomepage.value,
              onValueChanged: _cache[14] || (_cache[14] = ($event: any) => (showmetersonhomepage.value = $event.value))
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _hoisted_46,
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_unref(DxSwitch), {
              value: showkeysonhomepage.value,
              onValueChanged: _cache[15] || (_cache[15] = ($event: any) => (showkeysonhomepage.value = $event.value))
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_48, [
          _hoisted_49,
          _createElementVNode("div", _hoisted_50, [
            _createVNode(_unref(DxSwitch), {
              value: showalarmsonhomepage.value,
              onValueChanged: _cache[16] || (_cache[16] = ($event: any) => (showalarmsonhomepage.value = $event.value))
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_51, [
          _hoisted_52,
          _createElementVNode("div", _hoisted_53, [
            _createVNode(_unref(DxSwitch), {
              value: showappliancesandmanualsonhomepage.value,
              onValueChanged: _cache[17] || (_cache[17] = ($event: any) => (showappliancesandmanualsonhomepage.value = $event.value))
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_54, [
          _hoisted_55,
          _createElementVNode("div", _hoisted_56, [
            _createVNode(_unref(DxSwitch), {
              value: showgeneralnotesonhomepage.value,
              onValueChanged: _cache[18] || (_cache[18] = ($event: any) => (showgeneralnotesonhomepage.value = $event.value))
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_57, [
          _hoisted_58,
          _createElementVNode("div", _hoisted_59, [
            _createVNode(_unref(DxSwitch), {
              value: showcompliancesectionsonhomepage.value,
              onValueChanged: _cache[19] || (_cache[19] = ($event: any) => (showcompliancesectionsonhomepage.value = $event.value))
            }, null, 8, ["value"])
          ])
        ])
      ])
    ])
  ]))
}
}

})